if (!customElements.get('shipping-progress-bar')) {
  customElements.define(
    'shipping-progress-bar',
    class ShippingProgressBar extends HTMLElement {
      // LO: l'inizializzazione sta in connectedCallback e non nel constructor.
      // Motivo: su mobile la barra viene spostata nel DOM (vedi
      // loApplyPlacement) e ogni spostamento scollega e ricollega l'elemento,
      // facendo scattare disconnectedCallback. Il constructor invece gira una
      // volta sola: se la sottoscrizione a cartUpdate vivesse li', dopo lo
      // spostamento la barra smetterebbe di aggiornarsi al cambio carrello.
      connectedCallback() {
        this.track = this.querySelector('.shipping-progress-bar__track');
        this.fill = this.querySelector('[data-shipping-fill]');
        this.message = this.querySelector('[data-shipping-message]');
        this.currentRate = this.querySelector('[data-shipping-current-rate]');

        this.tier1 = parseInt(this.dataset.tier1, 10);
        this.tier2 = parseInt(this.dataset.tier2, 10);
        this.tier3 = parseInt(this.dataset.tier3, 10);
        this.cartUrl = this.dataset.cartUrl || (window.routes && window.routes.cart_url) || '/cart';

        // LO: nasconde il testo generico "Spese di spedizione calcolate al check-out"
        // (mostrato altrove nella pagina, in section main-product), mantenendo intatto
        // "Imposte incluse." - rimuove solo il link e il testo che lo segue, senza
        // dipendere dalla stringa esatta tradotta.
        this.hideStaticShippingText();

        if (!this.unsubscribeCartUpdate) {
          this.unsubscribeCartUpdate =
            typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
              ? subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh())
              : null;
        }

        // Re-sync with the real cart total on load, in case it drifted from
        // the server-rendered state (e.g. cart changed in another tab).
        this.refresh();

        this.loSchedulePlacement();
      }

      disconnectedCallback() {
        if (this.unsubscribeCartUpdate) {
          this.unsubscribeCartUpdate();
          this.unsubscribeCartUpdate = null;
        }
      }

      // --- posizione della barra su mobile -----------------------------------
      // Nel tema la barra viene renderizzata dentro buy-buttons, subito sotto il
      // pulsante "Aggiungi al carrello". Sulle schede prodotto che usano la barra
      // d'acquisto fissa quel pulsante e' nascosto su mobile, quindi la barra
      // spedizione resterebbe sospesa in mezzo ai contenuti descrittivi.
      //
      // Dove va a finire lo decide il TEMPLATE, non questo script: se nella
      // colonna informazioni esiste un blocco segnaposto con classe
      // "lo-shipping-slot", la barra ci entra dentro. Cosi' basta spostare quel
      // blocco dal personalizzatore per spostare la barra, senza toccare codice.
      // Se il segnaposto non c'e' si ripiega sui riferimenti storici.
      // Su desktop, dove il pulsante e' visibile, la barra torna al suo posto.
      loSchedulePlacement() {
        if (!this.loInitScheduled) {
          this.loInitScheduled = true;
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.loApplyPlacement(), { once: true });
          } else {
            this.loApplyPlacement();
          }
          window.addEventListener('resize', () => this.loApplyPlacement());
        } else if (document.readyState !== 'loading') {
          this.loApplyPlacement();
        }
      }

      loApplyPlacement() {
        // Solo sulle schede prodotto che usano la barra d'acquisto fissa: sulle
        // altre il pulsante e' visibile e la barra sta bene dov'e'.
        if (!document.querySelector('.lo-sticky-atc')) return;
        // Guardia di rientro: lo spostamento stesso fa scattare
        // disconnected/connectedCallback, che richiamerebbero questo metodo.
        if (this.loBusy) return;
        this.loBusy = true;

        try {
          const mobile = window.matchMedia('(max-width: 749px)').matches;

          if (mobile) {
            if (this.loAnchor) return;

            // Segnaposto invisibile: serve a rimettere la barra esattamente
            // dov'era quando si torna a desktop.
            const slot = document.querySelector('.lo-shipping-slot');
            if (slot) {
              if (this.parentNode === slot || !this.parentNode) return;
              this.loAnchor = document.createComment('lo-shipping-anchor');
              this.parentNode.insertBefore(this.loAnchor, this);
              slot.appendChild(this);
              return;
            }

            const target =
              document.querySelector('.schede-ideale-wrap') ||
              document.querySelector('variant-selects') ||
              document.querySelector('.product__description');
            if (!target || !target.parentNode || !this.parentNode) return;
            if (target.previousElementSibling === this) return;

            this.loAnchor = document.createComment('lo-shipping-anchor');
            this.parentNode.insertBefore(this.loAnchor, this);
            target.parentNode.insertBefore(this, target);
          } else {
            if (!this.loAnchor) return;
            const anchor = this.loAnchor;
            this.loAnchor = null;
            if (anchor.parentNode) {
              anchor.parentNode.insertBefore(this, anchor);
              anchor.parentNode.removeChild(anchor);
            }
          }
        } finally {
          this.loBusy = false;
        }
      }

      hideStaticShippingText() {
        const taxDiv = document.querySelector('.product__tax');
        if (!taxDiv) return;
        const link = taxDiv.querySelector('a');
        if (!link) return;
        const next = link.nextSibling;
        link.remove();
        if (next && next.nodeType === Node.TEXT_NODE) next.remove();
      }

      refresh() {
        fetch(`${this.cartUrl}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => this.render(cart.total_price))
          .catch((e) => console.error('[shipping-progress-bar]', e));
      }

      formatMoney(cents) {
        return (cents / 100).toLocaleString('it-IT', {
          style: 'currency',
          currency: 'EUR',
        });
      }

      compute(totalCents) {
        let percent;
        let remaining = 0;
        let free = false;

        if (totalCents >= this.tier3) {
          percent = 100;
          free = true;
        } else if (totalCents >= this.tier2) {
          percent = ((totalCents - this.tier2) * 100) / (this.tier3 - this.tier2);
          remaining = this.tier3 - totalCents;
        } else if (totalCents >= this.tier1) {
          percent = ((totalCents - this.tier1) * 100) / (this.tier2 - this.tier1);
          remaining = this.tier2 - totalCents;
        } else {
          percent = (totalCents * 100) / this.tier1;
          remaining = this.tier1 - totalCents;
        }

        percent = Math.min(100, Math.max(0, percent));

        return { percent, remaining, free };
      }

      // LO: le tariffe fisse passano dallo stesso formattatore dell'importo
      // mancante, cosi' tutte le cifre della barra hanno lo stesso formato.
      currentRateLabel(totalCents) {
        if (totalCents >= this.tier3) return 'Gratuita';
        if (totalCents >= this.tier2) return this.formatMoney(299);
        if (totalCents >= this.tier1) return this.formatMoney(399);
        return this.formatMoney(790);
      }

      render(totalCents) {
        const { percent, remaining, free } = this.compute(totalCents);

        if (this.fill) this.fill.style.width = `${percent}%`;
        if (this.track) this.track.setAttribute('aria-valuenow', Math.round(percent));
        if (this.currentRate) this.currentRate.textContent = this.currentRateLabel(totalCents);

        if (!this.message) return;

        // LO: un solo messaggio, che dice cosa serve per pagare meno. Quanto si
        // paga adesso lo dice gia' la riga sopra.
        if (free) {
          this.message.innerHTML = '🎉 Complimenti, hai raggiunto la <strong>spedizione gratuita</strong>!';
        } else if (totalCents >= this.tier2) {
          this.message.innerHTML = `Aggiungi <strong>${this.formatMoney(remaining)}</strong> e diventa <strong>gratuita</strong>`;
        } else if (totalCents >= this.tier1) {
          this.message.innerHTML = `Aggiungi <strong>${this.formatMoney(remaining)}</strong> e scende a <strong>${this.formatMoney(299)}</strong>`;
        } else {
          this.message.innerHTML = `Aggiungi <strong>${this.formatMoney(remaining)}</strong> e scende a <strong>${this.formatMoney(399)}</strong>`;
        }
      }
    }
  );
}
